var exports = {
  "Q": "xfd349460--76ec39--content",
};

module.exports = exports;
